import { ConditionalExpr } from '@angular/compiler';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AddShippingComponent } from 'src/app/checkout/add-shipping/add-shipping.component';
import { ShippingService } from 'src/app/services/shipping.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { CartService } from 'src/app/services/cart.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { MapLocatorComponent } from '../map-locator/map-locator.component';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { AdjustTokenService } from 'src/app/services/adjust-token.service';

@Component({
  selector: 'app-shipping-address-form',
  templateUrl: './shipping-address-form.component.html',
  styleUrls: ['./shipping-address-form.component.scss'],
})
export class ShippingAddressFormComponent implements OnInit {
  AddressForm: any;
  isSubmitted = false;
  userInfo: any;
  @Input() shippingAddress: any;
  @Input() showHeader: boolean;
  addressLabel = '';
  cart: any;
  location: any;
  ENV: string;
  isGuestUser: boolean;
  userLoggedIn: boolean = false;
  @Input() shoppingCart: any;
  @Input() stitchFields: any;
  items:any = [];
  constructor(
    private SS: SubjectService,
    private FB: FormBuilder,
    private SHS: ShippingService,
    private modalController: ModalController,
    private US: UserInfoService,
    private UTS: UtilitiesService,
    private GAS: GoogleAnalyticsService,
    private CS: CartService,
    private cdr: ChangeDetectorRef,
    private AAS: AdobeAnalyticsService,
    private adjustToken:AdjustTokenService
  ) {
    this.US.getUserInfo().subscribe(
      (getLoggedInUserResult: any) => {
        this.userInfo = getLoggedInUserResult;
        this.userLoggedIn = true;
        const accessToken = localStorage.getItem('AccessToken');
        this.ENV = localStorage.getItem('ENV');
        if (this.ENV && this.ENV == "mobile" && accessToken && (accessToken != null || accessToken.toLocaleLowerCase() != "null")) {
          this.isGuestUser = false;
        }
        else {
          this.isGuestUser = true;
        }
        if(!this.userLoggedIn){
          this.AddressForm.controls['addressLabel'].setValue('Other');
          this.addressLabel = 'Other';
          this.AddressForm.controls['nickname'].setValue("Guest User");
        } else if (!this.shippingAddress) {
          this.AddressForm.controls['addressLabel'].setValue('Home');
          this.addressLabel = 'Home';
        }
      },
      (e) => {
        if (e && e.error) {
          this.UTS.error(e.error.message);
        }
        this.isGuestUser = true;
        this.userLoggedIn = false;
        if(!this.userLoggedIn){
          this.AddressForm.controls['addressLabel'].setValue('Other');
          this.addressLabel = 'Other';
          this.AddressForm.controls['nickname'].setValue("Guest User");
        } else if (!this.shippingAddress) {
          this.AddressForm.controls['addressLabel'].setValue('Home');
          this.addressLabel = 'Home';
        }
        this.userInfo = null;
      }
    );
    this.AddressForm = this.FB.group({
      area: ['67MV+V5 Dubai - United Arab Emirates', [Validators.required]],
      nickname: ['',[Validators.pattern('^[a-zA-Z0-9 \-\ .=_@,;:\/-]+')]],
      flatOrVillaNumber: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9\s]+'),
          Validators.minLength(1),
        ],
      ],
      buildingNameAndNumber: ['', [Validators.required,Validators.pattern('^[a-zA-Z0-9ء-ي  \-\ .=_@,;:\/-]+')]],
      addressLabel: ['Other'],
      isPrimary: [false],
    });
    this.SS.mapService.subscribe(res=>{
      if(res){
        this.location = res;
        if(this.shippingAddress){
        this.shippingAddress['latitude'] = this.location.lat;
        this.shippingAddress['longitude'] = this.location.lng;
        this.shippingAddress['area'] = this.location.address || '';
        }
        this.AddressForm.controls['area'].setValue(this.location.address || '67MV+V5 Dubai - United Arab Emirates');
        // this.AddressForm.controls['addressLabel'].setValue('Other');
      }
    })
  }

  ngOnInit() {
    if (this.shippingAddress) {
      if (this.shippingAddress.nickname.toString().trim() == 'Home') {
        this.AddressForm.controls['addressLabel'].setValue('Home');
        this.addressLabel = 'Home';
      } else if (this.shippingAddress.nickname.toString().trim() == 'Office') {
        this.AddressForm.controls['addressLabel'].setValue('Office');
        this.addressLabel = 'Office';
      } else {
        this.AddressForm.controls['addressLabel'].setValue('Other');
        this.addressLabel = 'Other';
        this.AddressForm.controls['nickname'].setValue(
          this.shippingAddress.nickname.split('Other')[1]
        );
      }

      this.AddressForm.controls['area'].setValue(this.shippingAddress.area);
      // this.AddressForm.controls['nickname'].setValue(this.shippingAddress.nickname);
      this.AddressForm.controls['flatOrVillaNumber'].setValue(
        this.shippingAddress.flatOrVillaNumber
      );
      this.AddressForm.controls['buildingNameAndNumber'].setValue(
        this.shippingAddress.buildingNameAndNumber
      );
      this.AddressForm.controls['isPrimary'].setValue(
        this.shippingAddress.primary
      );
      this.cdr.detectChanges();
    }
  }
  changeLocation() {
    this.GAS.checkoutOptimizationAddressContactInfo('add_contact_info', 'checkout', 'Shipping Address','edit','checkout',this.cart?.items, this.stitchFields);
    this.dismiss();
    setTimeout(() => {
      this.openModal(this.shippingAddress).then(res=>{
        this.SS.previousStep.next(0);
      })
    }, 100);
  }

  async openModal(sa:any=null) {    
    const modal = await this.modalController.create({
      component: AddShippingComponent,
      cssClass: 'eand-full-screen',
      componentProps: { shippingAddress: sa,selectedLocation:this.location || null },
    });
    return await modal.present();
  }

  // async openModal() {
  //   const modal = await this.modalController.create({
  //     component: AddShippingComponent,
  //     cssClass: 'verification-modal modal-fullscreen',
  //   });
  //   return await modal.present();
  // }


  addAddress() {
    this.isSubmitted = true;
    this.cart = this.CS.getCart(); 
    this.GAS.saveLocation_addNewAddress_checkout(this.cart);
    this.AAS.addLinkCTAEvent("Save","other","Shipping","Shipping Address","Save address");
    this.optimizeCheckoutTracking('save');
    const data = {
      latitude: String(this.location && this.location.lat) || '25.23471965035523',
      longitude:  String(this.location && this.location.lng) || '55.29292345046997',
      area: this.location.address || '67MV+V5 Dubai - United Arab Emirates',
      emirate:(this.location?.emirate) ? this.location?.emirate : (this.shippingAddress?.emirate) ? this.shippingAddress?.emirate : null,
      city: (this.location?.city) ? this.location?.city : (this.shippingAddress?.city) ? this.shippingAddress?.city : null ,
      nickname: (this.AddressForm.value && this.AddressForm.value.nickname) ? this.addressLabel + ' ' + (this.AddressForm.value && this.AddressForm.value.nickname || '') : this.addressLabel,
      flatOrVillaNumber: this.AddressForm.value.flatOrVillaNumber,
      buildingNameAndNumber: this.AddressForm.value.buildingNameAndNumber,
      type: 'secondaryAddresses',
      // primary: false,
      primary: this.AddressForm.value.isPrimary
    };
    if (this.shippingAddress && this.shippingAddress.id) {
      data['id'] = this.shippingAddress.id;

      if (this.userInfo) {
        const payload = { items: [data] };
        this.SHS.updateaddress(payload).subscribe((res: any) => {
          if (res) {
            this.dismiss();
            this.SS.refreshAddress.next(res);
          }
          else{
          }
        },(e)=>{
          this.UTS.error(`You already have save address ${data.nickname}`);
          const env = this.UTS.getENV();
          if(env=="mobile"){
            this.UTS.toast(`You already have save address <b>${data.nickname}</b>`)
          }
        });
      } else {
        this.SHS.storeNotLoggedInAddress(data).subscribe((res: any) => {
          if (res) {
            this.SHS.storeSelectedAddress(data).subscribe((res: any) => {
              this.dismiss();
              this.SS.refreshAddress.next(res);
            });
          }
        },(e)=>{
          this.UTS.error(`You already have save address ${data.nickname}`);
          const env = this.UTS.getENV();
          if(env=="mobile"){
            this.UTS.toast(`You already have save address <b>${data.nickname}</b>`)
          }
        });
      }
    } else {
      if (this.userInfo) {
        this.SHS.addaddress(data).subscribe((res: any) => {
          if (res) {
            this.dismiss();
            this.SS.refreshAddress.next(res);
          }
        },(e)=>{
          this.UTS.error(`You already have save address ${data.nickname}`);
          const env = this.UTS.getENV();
          if(env=="mobile"){
            this.UTS.toast(`You already have save address <b>${data.nickname}</b>`)
          }
        });
      } else {
        this.SHS.storeNotLoggedInAddress(data).subscribe((res: any) => {
          if (res) {
            this.SHS.storeSelectedAddress(data).subscribe((res: any) => {
              this.dismiss();
              this.SS.refreshAddress.next(res);
            });
          }
        });
      }
    }
    this.GAS.checkoutOptimizationAddressContactInfo('add_contact_info', 'checkout', 'Shipping Address','save','checkout',this.cart?.items, this.stitchFields);
    this.ENV = this.UTS.getENV();
    this.items = this.cart?.items || [];
    if (this.ENV == 'mobile' && this.items && this.items?.length > 0) {
      this.items?.forEach(element => {
        if (element && element.commerceItemType && element.commerceItemType == 'mobileDevicesSku') {
          this.adjustToken.devicesAdjustTracking('ec_add_shipping_info', AppSettings.ADD_SHIPPING_ADDRESS_ADJUST_TOKEN, element);
        }
      });
    }
  }

  get errorControl() {
    return this.AddressForm.controls;
  }
  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  changeAddressLabel(e) {
    this.addressLabel = e.target.value;
    if (this.addressLabel != 'Other') {
      this.AddressForm.controls['nickname'].setValue('');
    }
  }
  optimizeCheckoutTracking(info){
    if (this.shoppingCart?.items?.length > 0) {
      this.GAS.checkoutOptimizationTracking('add_shipping_info', this.shoppingCart?.items, this.shoppingCart, '', info, 'checkout');
    }
  }

}
